<main class="text-start">
    <h1 class="page-title">{{ 'dashboard.title' | translate }}</h1>

    <div *ngIf="dashboardLoaded; else dashboardSkeleton" class="flex xl:flex-row-reverse flex-col-reverse xl:gap-6 gap-0">
        <div class="2xl:w-2/7 xl:w-3/10 w-full h-fit bg-[#F6F6F6] xl:rounded-md rounded-b-md p-3.5">
            <div *ngIf="!movePieChart" class="w-full bg-white rounded-xl px-5 py-5">
                <div class=" w-full flex justify-between items-center">
                    <p class="section-title">{{ 'dashboard.sections.ages_by_users' | translate }}</p>
                    <div class="w-[110px]">
                        <app-date-range-picker-input
                            [ngModel]="sectionRanges.salesByCategoryA"
                            (ngModelChange)="onAgeRangeChange($event)"
                            [placeholder]="'dashboard.date_picker_all_time' | translate"
                            [presets]="['today', 'yesterday', 'thisWeek', 'thisMonth', 'lastMonth']"
                            [lang]="languageService.currentLang()"
                        />
                    </div>
                </div>

                <div class="mt-2.5">
                    <app-pie-chart [data]="ageChartData"></app-pie-chart>
                  <div>
                      <div class="grid grid-cols-2 gap-x-8 gap-y-4 text-xs mt-5">

                          <div *ngFor="let item of ageChartData"
                              class="flex items-center gap-2 justify-start"
                          >
                              <div class="w-2.5 h-2.5 rounded-full"
                                  [style.background]="item.color"
                              ></div>
                              <p>{{ item.label }}</p>
                          </div>
                      </div>
                  </div>
                </div>
            </div>

            <div class="w-full bg-white rounded-xl px-5 py-5 mt-3">
                <div class=" w-full flex justify-start items-center">
                    <p class="text-sm text-[#4B4B4B]">{{ 'dashboard.sections.reviews' | translate }}</p>
                </div>

                <!-- TODO hide sidebar -->
                <!-- TODO add pagination -->
                <div class="mt-6 h-[27.4rem] overflow-y-scroll">

                    <ng-container *ngIf="vendorReviews">
                    <div class="flex justify-start  gap-3 w-full my-7" *ngFor="let review of vendorReviews.results">
                        <div class="w-10 h-10 rounded-full" [style]="'background-color:' + getReviewBackgroundColor(review.id)">
                        </div>
                        <div class="w-[calc(100%-65px)] sm:text-xs text-[0.7rem]">
                            <div class="text-[#8E8E8E] flex justify-between items-center w-full">
                                <p>{{  review.name }}</p>
                                <p>{{  review.date | date: 'short' }}</p>
                            </div>
                            <div class="mt-1.5">
                                <i class="bi bi-star-fill" [ngClass]="review.rating >= 1 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                <i class="bi bi-star-fill" [ngClass]="review.rating >= 2 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                <i class="bi bi-star-fill" [ngClass]="review.rating >= 3 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                <i class="bi bi-star-fill" [ngClass]="review.rating >= 4 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                <i class="bi bi-star-fill" [ngClass]="review.rating >= 5 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                            </div>
                            <p>{{ review.comment }}</p>
                        </div>
                    </div>

                    </ng-container>

                </div>


                <button class="w-full border border-[#E5E7EB] py-1.5 rounded-lg">{{ 'dashboard.more' | translate }}</button>
            </div>

            <div class="w-full bg-white rounded-xl px-5 py-5 mt-3">
                <div class=" w-full flex justify-start items-center">
                    <p class="text-sm text-[#4B4B4B]">{{ 'dashboard.sections.top_products' | translate }}</p>
                </div>

                <div class="mt-6">
                    <table class="most-sold-table">
                        <thead>
                            <tr>
                                <th class="text-xs">#</th>
                                <th class="text-xs">{{ 'dashboard.tables.product_name' | translate }}</th>
                                <th class="text-xs">{{ 'dashboard.tables.order_count' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let product of topProducts; let i = index">
                                <td class="text-xs">{{ (i + 1) | number: '2.0-0' }}</td>
                                <td class="w-full">
                                    <div class="flex justify-start gap-2 items-center">
                                        <img [src]="product.cover_image || 'dashboard/place-holders/product-1.png'" class="w-9 h-9 rounded object-cover" alt="">
                                        <div class="text-[0.7rem] font-medium">
                                            <p>{{ languageService.currentLang() === 'ar' ? product.name_ar : product.name_en }}</p>
                                            <p class="text-[#6B7280]">{{ languageService.currentLang() === 'ar' ? product.subcategory_name_ar : product.subcategory_name_en }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-xs">{{ product.order_count }}</td>
                            </tr>
                            <tr *ngIf="topProducts.length === 0">
                                <td colspan="100%" class="text-start text-xs text-[#8E8E8E]">{{ 'dashboard.tables.no_products' | translate }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="[container-type:inline-size] 2xl:w-5/7 xl:w-7/10 w-full h-fit bg-[#F6F6F6] xl:rounded-md rounded-t-md p-3.5">
            <div class="w-full flex gap-4 md:flex-row-reverse flex-col-reverse">
                <div class="bg-white w-full rounded-xl h-full px-3 py-4">
                    <app-overview-card [title]="'dashboard.cards.received_payments' | translate" [number]="paymentStats.received_payments" [showCurrency]="true" iconClass="bi bi-currency-dollar"
                        iconColor="#8280FF" iconBgColor="#E4E4FF"></app-overview-card>
                </div>
                <div class="bg-white w-full rounded-xl h-full p-3 py-4">
                    <app-overview-card [title]="'dashboard.cards.pending_payments' | translate" [number]="paymentStats.pending_payments" [showCurrency]="true" iconClass="bi bi-file-earmark-play"
                        iconColor="#FEC53D" iconBgColor="#FEF2D6"></app-overview-card>
                </div>
                <div class="bg-white w-full rounded-xl h-full p-4 py-4">
                    <app-overview-card [title]="'dashboard.cards.total_sales' | translate" [number]="paymentStats.total_sales" [showCurrency]="true" iconClass="bi bi-coin"
                        iconColor="#8280FF" iconBgColor="#E4E4FF"></app-overview-card>
                </div>
            </div>

            <div class="w-full grid grid-cols-1 @xl:grid-cols-2 @5xl:grid-cols-4 gap-4 lg:flex-row flex-col mt-3">
                <div class="bg-white w-full rounded-xl h-full p-4 py-4">
                    <app-overview-card [title]="'dashboard.cards.out_for_delivery' | translate" [number]="orderStats.outForDelivery" iconClass="bi bi-truck"
                    iconColor="#80A4FF" iconBgColor="#E4ECFF"></app-overview-card>
                </div>
                <div class="bg-white w-full rounded-xl h-full px-4 py-4">
                    <app-overview-card [title]="'dashboard.cards.delivered_orders' | translate" [number]="orderStats.delivered" iconClass="bi bi-check2-circle"
                        iconColor="#80FF8F" iconBgColor="#E4FFE7"></app-overview-card>
                </div>
                <div class="bg-white w-full rounded-xl h-full p-4 py-4">
                    <app-overview-card [title]="'dashboard.cards.total_orders' | translate" [number]="orderStats.total" iconClass="bi bi-box-seam"
                    iconColor="#8280FF" iconBgColor="#E4E4FF"></app-overview-card>
                </div>
                <div class="bg-white w-full rounded-xl h-full p-4 py-4">
                    <app-overview-card [title]="'dashboard.cards.preparing_orders' | translate" [number]="orderStats.preparing" iconClass="bi bi-stopwatch"
                        iconColor="#FFBF80" iconBgColor="#FFF1E4"></app-overview-card>
                </div>
            </div>

            <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">

                <div class=" w-full flex justify-between items-center">
                    <p class="section-title">{{ 'dashboard.sections.sales' | translate }}</p>
                    <div class="w-[170px]">
                        <app-date-range-picker-input
                            [ngModel]="sectionRanges.salesByCategoryB"
                            (ngModelChange)="onSalesRangeChange($event)"
                            [placeholder]="'dashboard.date_picker_last_month' | translate"
                            [presets]="['thisWeek', 'thisMonth', 'lastMonth', 'last3Months', 'thisYear']"
                            [lang]="languageService.currentLang()"
                        />
                    </div>
                </div>

                <div class="mt-6">
                    <app-line-chart [labels]="salesChartLabels" [datasets]="salesChartData"></app-line-chart>
                </div>

            </div>

            <div *ngIf="movePieChart" class="w-full bg-white rounded-xl mt-3 px-5 py-5">

                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <p class="section-title">{{ 'dashboard.sections.categories_by_sales' | translate }}</p>
                    <div class="w-full sm:w-[170px]">
                        <app-date-range-picker-input
                            [(ngModel)]="sectionRanges.salesByCategoryB"
                            [placeholder]="'dashboard.date_picker_last_month' | translate"
                            [presets]="['today', 'yesterday', 'thisWeek', 'thisMonth', 'lastMonth']"
                            [lang]="languageService.currentLang()"
                        />
                    </div>
                </div>

                <div class="mt-2.5 md:flex md:items-end">
                    <app-pie-chart class="w-1/2"></app-pie-chart>
                    <div class="ms-2.5 md:w-1/2">
                        <p class="text-xs text-[#8E8E8E] text-center mt-5 mb-3">{{ 'dashboard.no_data' | translate }}</p>
                    </div>
                </div>

            </div>

            <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
              <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <p class="section-title">{{ 'dashboard.sections.reviews' | translate }}</p>
                <div class="max-sm:w-full flex max-sm:justify-start gap-2">
                    <div class="w-[170px]">
                        <app-date-range-picker-input
                            [(ngModel)]="sectionRanges.ratings"
                            [placeholder]="'dashboard.date_picker_last_month' | translate"
                            [presets]="['today', 'yesterday', 'thisWeek', 'thisMonth', 'lastMonth']"
                            [lang]="languageService.currentLang()"
                        />
                    </div>
                    <div class="table-header-btn bg-[#0768F7] text-white">
                        <p class="text-xs">{{ 'dashboard.print' | translate }}</p>
                        <i class="bi bi-printer text-xs text-white"></i>
                    </div>
                </div>
              </div>
              <div class="mt-5">
                  <app-bar-chart *ngIf="ratingChartData" [labels]="ratingChartLabels" [datasets]="ratingChartData" [beginAtZero]="false"></app-bar-chart>
              </div>
            </div>

            <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
                <div class="w-full flex justify-start items-center">
                    <p class="section-title">{{ 'dashboard.sections.delivery_orders' | translate }}</p>
                </div>
                <div class="mt-6">
                    <table class="generic-table">
                        <thead>
                            <tr>
                                <th>{{ 'dashboard.tables.order_number' | translate }}</th>
                                <th class="md:table-cell hidden">{{ 'dashboard.tables.customer_name' | translate }}</th>
                                <th>{{ 'dashboard.tables.status' | translate }}</th>
                                <th class="md:table-cell hidden">{{ 'dashboard.tables.total_order' | translate }}</th>
                                <th class="md:table-cell hidden">{{ 'dashboard.tables.details' | translate }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let order of ordersResponse?.results" [routerLink]="['/orders', order.order_uuid]" class="cursor-pointer">
                                <td class="p-3 text-gray-600">#{{ order.order_uuid | slice:0:8 }}</td>
                                <td class="p-3 justify-start items-center gap-2 md:flex hidden">
                                    <div class="bg-[#FCC5F3] w-6 h-6 rounded-full">

                                        <img src="dashboard/place-holders/avatar-female.png"
                                            class="w-6 h-6 rounded-full" alt="">
                                    </div>
                                    <span>{{ order.name }}</span>
                                </td>
                                <td>
                                    <span [ngClass]="{
                                            'bg-purple-100 text-purple-700': order.status === 'preparing_order',
                                            'bg-blue-100 text-blue-700': order.status === 'placed',
                                            'bg-emerald-100 text-emerald-700': order.status === 'ready_for_pickup',
                                            'bg-yellow-100 text-yellow-700': order.status === 'out_for_delivery',
                                            'bg-green-100 text-green-700': order.status === 'delivered',
                                            'bg-red-100 text-red-700': order.status === 'cancelled',
                                            'bg-rose-100 text-rose-700': order.status === 'refunded'
                                            }" class="status-chip">
                                        {{ getOrderStatusKey(order.status) | translate }}
                                    </span>
                                </td>
                                <td class="md:table-cell hidden">{{ order.total_price }} {{ 'common.currency' | translate }}</td>
                                <td class="md:table-cell hidden">
                                    <div class="flex items-center justify-start gap-1">
                                        <img src="dashboard/place-holders/product-1.png"
                                            class="w-[26px] h-[26px] rounded" alt="">
                                        <img src="dashboard/place-holders/product-2.png"
                                            class="w-[26px] h-[26px] rounded" alt="">
                                    </div>
                                </td>
                                <td>
                                    <i class="bi" [class.bi-arrow-left-circle]="languageService.isRtl()" [class.bi-arrow-right-circle]="!languageService.isRtl()"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Pagination -->
                    <app-table-pagination *ngIf="ordersResponse" [count]="ordersResponse.count" [limit]="ordersPagination.limit" [offset]="ordersPagination.offset"
                        (pageChange)="updateOrdersPagination($event)" />
                </div>
            </div>

            <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
              <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <p class="section-title">{{ 'dashboard.sections.inventory' | translate }}</p>
                <div class="max-sm:w-full flex max-sm:justify-start gap-2">
                  <div class="w-[170px]">
                      <app-date-range-picker-input
                          [(ngModel)]="sectionRanges.inventory"
                          [placeholder]="'dashboard.date_picker_last_month' | translate"
                          [presets]="['today', 'yesterday', 'thisWeek', 'thisMonth', 'lastMonth']"
                          [lang]="languageService.currentLang()"
                      />
                  </div>
                  <div class="table-header-btn bg-[#0768F7] text-white">
                    <p class="text-xs">{{ 'dashboard.print' | translate }}</p>
                    <i class="bi bi-printer text-xs text-white"></i>
                  </div>
                </div>
              </div>
                <div class="mt-6">
                  <table class="generic-table">
                    <thead>
                      <tr>
                        <th class="text-xs">#</th>
                        <th class="text-xs">{{ 'dashboard.tables.product_name' | translate }}</th>
                        <th class="text-xs md:table-cell hidden">{{ 'dashboard.tables.category_name' | translate }}</th>
                        <th class="text-xs">{{ 'dashboard.tables.available_quantity' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of lowStockResponse?.results; let i = index">
                        <td class="text-xs">{{ lowStockPagination.offset + i + 1 | number: '2.0-0' }}</td>
                        <td class="w-full">
                          <div class="flex justify-start gap-2 items-center">
                            <img [src]="item.cover_image || 'dashboard/place-holders/product-1.png'" class="w-9 h-9 rounded object-cover" alt="">
                            <div class="text-[0.7rem] font-medium">
                              <p>{{ languageService.currentLang() === 'ar' ? item.product_name_ar : item.product_name_en }}</p>
                              <p *ngIf="lowStockVariantLabel(item)" class="text-[#6B7280]">{{ lowStockVariantLabel(item) }}</p>
                            </div>
                          </div>
                        </td>
                        <td class="text-xs md:table-cell hidden">{{ languageService.currentLang() === 'ar' ? item.category_name_ar : item.category_name_en }}</td>
                        <td class="text-xs">{{ item.stock }}</td>
                      </tr>
                      <tr *ngIf="!lowStockResponse?.results?.length">
                        <td colspan="100%" class="text-start text-xs text-[#8E8E8E]">{{ 'dashboard.tables.no_inventory' | translate }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <app-table-pagination *ngIf="lowStockResponse" [count]="lowStockResponse.count" [limit]="lowStockPagination.limit" [offset]="lowStockPagination.offset"
                      (pageChange)="updateLowStockPagination($event)" />
                </div>
            </div>
        </div>
    </div>
</main>

<ng-template #dashboardSkeleton>
  <div class="flex xl:flex-row-reverse flex-col-reverse xl:gap-6 gap-0 animate-pulse">

      <div class="2xl:w-2/7 xl:w-3/10 w-full bg-[#F6F6F6] xl:rounded-md rounded-b-md p-3.5 space-y-3">

          <div class="bg-white rounded-xl p-5">
              <div class="flex justify-between items-center">
                  <div class="w-20 h-8 bg-gray-100 rounded"></div>
                  <div class="w-28 h-5 bg-gray-200 rounded"></div>
              </div>

              <div class="flex justify-center mt-6">
                  <div class="w-48 h-48 rounded-full bg-gray-100"></div>
              </div>

              <div class="grid grid-cols-2 gap-4 mt-6">
                  <div *ngFor="let i of [1,2,3,4]" class="h-4 bg-gray-100 rounded">
                  </div>
              </div>
          </div>

          <div class="bg-white rounded-xl p-5">
              <div class="flex justify-start">
                  <div class="w-20 h-5 bg-gray-200 rounded"></div>
              </div>

              <div class="space-y-6 mt-6">
                  <div *ngFor="let i of [1,2,3,4]">
                      <div class="flex justify-start gap-3">
                          <div class="w-10 h-10 rounded-full bg-gray-200"></div>
                          <div class="flex-1">
                              <div class="h-3 w-full bg-gray-100 rounded"></div>
                              <div class="h-3 w-1/2 bg-gray-100 rounded mt-2"></div>
                              <div class="flex gap-1 mt-3 justify-start">
                                  <div *ngFor="let x of [1,2,3,4,5]" class="w-3 h-3 rounded-full bg-gray-200">
                                  </div>
                              </div>
                              <div class="h-3 w-3/4 bg-gray-100 rounded mt-3"></div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="h-10 bg-gray-100 rounded-lg mt-6"></div>
          </div>

          <div class="bg-white rounded-xl p-5">
              <div class="flex justify-start">
                  <div class="w-32 h-5 bg-gray-200 rounded"></div>
              </div>

              <div class="space-y-3 mt-6">
                  <div *ngFor="let i of [1,2,3]" class="h-10 bg-gray-100 rounded">
                  </div>
              </div>
          </div>

      </div>

      <div class="2xl:w-5/7 xl:w-7/10 w-full bg-[#F6F6F6] xl:rounded-md rounded-t-md p-3.5">

          <div class="grid md:grid-cols-3 gap-4">
              <div *ngFor="let i of [1,2,3]" class="bg-white rounded-xl p-4">
                  <div class="flex justify-between">
                    <div class="h-full flex flex-col justify-start items-start gap-2">
                      <div class="w-24 h-4 bg-gray-100 rounded"></div>
                      <div class="w-14 h-6 bg-gray-200 rounded"></div>
                    </div>
                    <div class="w-10 h-10 rounded-full bg-gray-100"></div>
                  </div>
              </div>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 @5xl:grid-cols-4 gap-4 mt-4">
              <div *ngFor="let i of [1,2,3,4]" class="flex justify-between bg-white rounded-xl h-24 p-4">
                <div class="h-full flex flex-col justify-start items-start gap-2">
                  <div class="w-20 h-4 bg-gray-100 rounded"></div>
                  <div class="w-12 h-6 bg-gray-200 rounded"></div>
                </div>
                <div class="w-10 h-10 bg-gray-100 rounded-full"></div>
              </div>
          </div>

          <div class="bg-white rounded-xl mt-4 p-5">
              <div class="flex justify-between">
                  <div class="w-40 h-8 bg-gray-100 rounded"></div>
                  <div class="w-24 h-5 bg-gray-200 rounded"></div>
              </div>
              <div class="h-[300px] bg-gray-100 rounded-xl mt-6"></div>
          </div>

          <div class="bg-white rounded-xl mt-4 p-5">
              <div class="flex justify-between">
                  <div class="w-52 h-8 bg-gray-100 rounded"></div>
                  <div class="w-24 h-5 bg-gray-200 rounded"></div>
              </div>

              <div class="h-[280px] bg-gray-100 rounded-xl mt-6"></div>
          </div>

          <div class="bg-white rounded-xl mt-4 p-5">
              <div class="w-32 h-5 bg-gray-200 rounded me-auto"></div>
              <div class="space-y-3 mt-6">
                  <div *ngFor="let i of [1,2,3,4,5]" class="h-12 bg-gray-100 rounded"></div>
              </div>

          </div>

          <div class="bg-white rounded-xl mt-4 p-5">
              <div class="flex justify-between">
                  <div class="w-52 h-8 bg-gray-100 rounded"></div>
                  <div class="w-24 h-5 bg-gray-200 rounded"></div>
              </div>
              <div class="space-y-3 mt-6">
                  <div *ngFor="let i of [1,2,3]"class="h-12 bg-gray-100 rounded">
                  </div>
              </div>
          </div>
      </div>

  </div>
</ng-template>
